export default __webpack_public_path__ + "static/media/primerLugar.d161d386.jpeg";